(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-hd"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Lleva el foco al bloque del código tras la recarga del POST
    const success = document.querySelector('.hd-news__success');
    if (success) {
      success.scrollIntoView({ block: 'center' });
      success.focus({ preventScroll: true });
    }

    if (window.__hdNewsCopyBound) return;
    window.__hdNewsCopyBound = true;

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-hd-copy]');
      if (!btn) return;
      try {
        await navigator.clipboard.writeText(btn.dataset.hdCopy);
        const original = btn.textContent;
        btn.textContent = btn.dataset.copiedLabel;
        setTimeout(() => { btn.textContent = original; }, 2000);
      } catch {
        // Sin Clipboard API (http, iframe): selecciona el código para copia manual
        const codeEl = btn.parentElement.querySelector('code');
        const range = document.createRange();
        range.selectNodeContents(codeEl);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
